module.exports = __webpack_public_path__ + "a081ca407a078e7f4c598c43ac4c7b2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-26-harrison/diary.jpg
// module id = 1012
// module chunks = 0